import { LiveCasinoStore } from "@state/stores/games";
import { createContext } from "react";

export default createContext<LiveCasinoStore | null>(null);
